import React from "react";
import assets from "../../../shared/constants/assetVariables";
const csrdDashboardFeature = [
  {
    id: "1",
    icon: assets.icons.csrdDashboardIcon1,
    heading: "Compliance Tracking",
    description: "Live monitoring of CSRD disclosure completeness and real-time validation alerts.",
  },
  {
    id: "2",
    icon: assets.icons.csrdDashboardIcon2,
    heading: "Materiality Risk Assessment",
    description: "Visual analytics to track material ESG risks and their impact on compliance.",
  },
  {
    id: "3",
    icon: assets.icons.csrdDashboardIcon3,
    heading: "Benchmarking & Peer Comparisons",
    description: "Industry-specific benchmarking to assess sustainability performance.",
  },
];
function Section_4() {
  return (
    <section className="csrd-landing-page-section-6-container">
      <div className="csrd-landing-page-section-6-header-container">
        <div
          className="csrd-landing-page-section-6-header"
          data-aos="fade-down"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true">
          <span className="text-1">CSRD</span> <span className="text-2">Dashboard</span>
        </div>
        <div
          className="csrd-landing-page-section-6-description"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true">
          A centralized compliance tracking dashboard that provides real-time insights into
          reporting status, missing disclosures, and compliance validation.
        </div>
      </div>
      <div
        className="key-feature-heading"
        data-aos="zoom-in"
        data-aos-delay="100"
        data-aos-duration="700"
        data-aos-once="true">
        Key Features
      </div>
      <div className="key-feature-content-container">
        <div className="key-feature-inner-content-container">
          <div
            className="key-feature-left-container"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="700"
            data-aos-once="true">
            {csrdDashboardFeature?.map((ele) => {
              return (
                <div className="key-feature-card-container" key={ele?.id}>
                  <div className="dma-icon">
                    <img src={ele?.icon} alt="dm1-icon" />
                  </div>
                  <div className="feature-header-description-container">
                    <div className="feature-header">{ele?.heading}</div>
                    <div className="feature-description">{ele?.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className="key-feature-right-container"
            data-aos="fade-left"
            data-aos-delay="100"
            data-aos-duration="700"
            data-aos-once="true">
            <div className="csrd-dashboard-img-container">
              <img
                src={assets.images.csrddc_bg1}
                alt="csrd-dashboard-green-circle"
                className="csrd-dashboard-green-circle"
              />
              <img
                src={assets.images.csrdDashboardImg}
                alt="csrd-dashboard"
                className="csrd-dashboard-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section_4;
